export default "__VITE_ASSET__tZG7TJFA__"